import { actions } from "./state";

export const changeOrganisasi = (props) => {
	return {
		type: actions.CHANGE_ORGANISASI,
		payload: props,
	};
};

export const changeLoadingOrganisasi = (props) => {
	return {
		type: actions.CHANGE_LOADING_ORGANISASI,
		payload: props,
	};
};

export const changeLokasi = (props) => {
	return {
		type: actions.CHANGE_LOKASI,
		payload: props,
	};
};

export const changeLoadingLokasi = (props) => {
	return {
		type: actions.CHANGE_LOADING_LOKASI,
		payload: props,
	};
};
